/** Shared CSV helpers (RFC 4180 quoting). Several export paths grew private
 *  copies of this escape rule — new exporters should import these instead. */

/** A tab/CR first character, or = + - @ as the first character after any leading
 *  whitespace (\s also covers NBSP, newlines and the BOM). */
const FORMULA_START = /^(?:[\t\r]|\s*[=+\-@])/;

export function csvEscape(value: string | number): string {
  let s = String(value);
  // Spreadsheet formula-injection guard (OWASP CSV Injection): free-text
  // values starting with = + - @ (or tab/CR) would be EVALUATED by Excel on
  // open, and spreadsheets skip leading whitespace first, so "  =1+1" is a
  // formula too. Prefix with a quote to force text. Numbers are exempt
  // (negative numbers are data), so pass money as a number, not toFixed().
  if (typeof value === 'string' && FORMULA_START.test(s)) {
    s = `'${s}`;
  }
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/** Rows to CSV text with CRLF line endings and a UTF-8 BOM so Excel detects
 *  the encoding (m², £) without an import dialog. */
export function toCsv(rows: (string | number)[][]): string {
  return '﻿' + rows.map(r => r.map(csvEscape).join(',')).join('\r\n');
}
